import React from 'react';
import FeaturePageTemplate from '../../components/FeaturePageTemplate';

const NetSheetFeature = () => {
  return (
    <FeaturePageTemplate
      seoKey="netSheetFeature"
      heroHeadline="Stop guessing what sellers will walk away with."
      heroSubheadline="Generate clear seller proceeds instantly and build immediate trust."
      ctaText="Show Seller Proceeds"
      problemText="Sellers care about one thing: what they net. If you can't show it clearly, you lose trust. Vague conversations lead to lost listings."
      rootCauseText="Most agents explain numbers verbally instead of showing them."
      solutionIntro="Generate clear seller proceeds instantly."
      solutionBullets={[
        "Accurate net calculations",
        "Simple, client-friendly PDF",
        "Perfect for listing appointments",
        "Builds immediate trust"
      ]}
      beforeItems={["Vague conversations", "Weak presentations", "Lost trust"]}
      afterItems={["Confident presentations", "Clear numbers", "Won listings"]}
      proofText="Win more listings with clarity."
    />
  );
};

export default NetSheetFeature;
